import React, { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { format } from 'date-fns';
import Button from 'components/Button';
import Message from 'components/Message';
import { useEffectDidUpdate } from 'helpers/react-hooks';
import './DatePicker.scss';

const messages = defineMessages({
  done: {
    id: 'date-picker.done',
    defaultMessage: 'Done',
  },
});

const DatePicker = ({ className, dateFnsLocale, defaultValue, isDesktop, isValidDate = null, modifiers, onChange }) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue);
  const handleOnDayClick = (day, { disabled }) => {
    let validDate = !disabled;
    if (isValidDate) {
      validDate = isValidDate(day);
    }

    if (validDate) {
      return setSelectedDate(day);
    }

    return setSelectedDate(defaultValue);
  };

  useEffectDidUpdate(() => {
    if (isDesktop) {
      onChange(selectedDate);
    }
  }, [selectedDate]);

  return (
    <div className={classNames('date-picker', className)}>
      <DayPicker
        data-cypress="react-day-picker"
        defaultMonth={selectedDate}
        enableOutsideDaysClick
        formatters={{
          formatWeekdayName: weekday => format(weekday, 'iiiii', { locale: dateFnsLocale }),
        }}
        locale={dateFnsLocale}
        mode="single"
        modifiers={modifiers}
        onDayClick={handleOnDayClick}
        selected={selectedDate}
        showOutsideDays
      />
      {!isDesktop && (
        <div className="date-picker__footer">
          <Message
            message={messages.done}
            as={Button}
            className="date-picker__done-button"
            onClick={() => onChange(selectedDate)}
          />
        </div>
      )}
    </div>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
  dateFnsLocale: PropTypes.shape({}),
  defaultValue: PropTypes.instanceOf(Date),
  isDesktop: PropTypes.bool,
  isValidDate: PropTypes.func,
  modifiers: PropTypes.shape({
    disabled: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ after: PropTypes.instanceOf(Date) })]),
    today: PropTypes.instanceOf(Date),
  }),
  onChange: PropTypes.func,
};

export default DatePicker;
